<template>
    <ac-modal :title="'Payment Details'" ref="modal">
        <template v-if="widgetReady">
            <div class="row">
                <div v-for="d in details" class="col-sm-12 col-md-6 col-lg-6">
                    <p><strong>Patient:</strong> {{ d.patient }}</p>
                    <p><strong>Provider Selection:</strong> {{ d.planEffectiveDate | shortDate }}</p>
                    <p><strong>DiscountId:</strong> {{ d.discountSettingsId }}</p>
                    <p><strong>Individual Cost(No Discounts):</strong> {{ d.fullMemberFee | currency }}</p>
                    <p><strong>Fees:</strong></p>
                    <div v-for="fee in d.feeDetails">
                        <span>{{ fee }}</span>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../../../global/framework/api.js";

    export default {
        name: "PayrollDeductionsDetailsModal",
        components: {AcModal},
        data() {
            return {
                widgetReady: false,
                details: []
            };
        },
        methods: {
            async showModal({paymentRecordId, consumerId}) {
                this.widgetReady = false;
                this.details = await api.get('PaymentReport', paymentRecordId, 'GetPayrollDeductionsDetails');
                this.details = this.details.filter((el) => el.consumerId == consumerId);
                this.widgetReady = true;
                this.$refs.modal.open();
            },
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }
</style>